module.exports = __webpack_public_path__ + "media/styles/images/png/oval-gray-dark-ae9a466af1903d559997311b36475693.png";